export default __webpack_public_path__ + "media/images/gps-icon-0df1e7aba42a6982f9aa813469a7967c.svg";